<template>
  <div class="text-center">
    <proporsion-of-failed-vs-finished-chart
      v-show="!showBlankslate"
      :date-range="dateRange"
      :on-load="onLoad"
      :height="'170vh'"
    />
    <img
      v-show="showBlankslate"
      :src="'/assets/img/blankslate/blankslate-round-chart.svg'"
    >
  </div>
</template>

<script>
import ProporsionOfFailedVsFinishedChart from '@/apps/payments/payments/indicator/components/presentational/ProporsionOfFailedVsFinishedChart';

export default {
  name: 'proporsion-of-failed-vs-finished-chart-container',
  components: {
    ProporsionOfFailedVsFinishedChart
  },
  props: {
    dateRange: {
      required: true
    }
  },
  data: () => ({
    showBlankslate: false
  }),
  watch: {
    dateRange: {
      deep: true,
      handler() {
        this.showBlankslate = false;
      }
    }
  },
  methods: {
    onLoad(data) {
      if (!data.finished && !data.returned) {
        this.showBlankslate = true;
      }
    }
  }
};
</script>
